import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import { findWhere } from 'underscore'

import { toggleReplyFlare } from '~/actions/statement'

export default class extends React.Component {
    static propTypes = {
		ID: PropTypes.number.isRequired,
		date: PropTypes.string.isRequired,
		reply: PropTypes.string.isRequired,
		flares: PropTypes.array.isRequired
	};

    flare = () => {
		this.props.dispatch( toggleReplyFlare(this.props.ID) )
	};

    render() {
		return (
			<div className="col-sm-9 col-sm-offset-3 sub-reply">
	    		<p className="lead">{this.props.reply}</p>
	    		<p className="mbot20">
	    			{this.props.flares.length} <i className={findWhere(this.props.flares, function(obj) { return obj.ID == this.props.ID }) ? 'fa fa-arrow-up text-mid-success' : 'fa fa-arrow-up text-black'} onClick={this.flare}></i>
    			</p>
    		</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Statement/components/SubReplyPart.jsx